export default __webpack_public_path__ + "static/media/google-dark.c2f4dc5c.svg";